<template>
  <svg
    clip-rule="evenodd"
    fill-rule="evenodd"
    stroke-linejoin="round"
    stroke-miterlimit="2"
    viewBox="100 153.374 360 93.252"
    xmlns="http://www.w3.org/2000/svg"
    height="30"
  >
    <g transform="matrix(1.56726 0 0 1.56726 100 152.59)">
      <path
        d="m20.8.5h-20.8v40.3l12.3-18.6 13.6 9 14.2-21.5c-4.2-5.7-10.8-9.2-19.3-9.2"
        fill="#1c305d"
        fill-rule="nonzero"
      />
      <path
        d="m41.3 11.5-14.8 22.4-13.6-9-12.9 19.4v11.6h20.8c15.7 0 24.9-11.9 24.9-27.6.1-5.9-1.4-11.7-4.4-16.8"
        fill="#88addb"
        fill-rule="nonzero"
      />
      <path
        d="m158.8 39.6c-2.6 2.5-6 3.8-9.6 3.8-8 0-13.9-6.6-13.9-14.6s6-14.6 13.9-14.6c3.6 0 7 1.4 9.6 3.8l-1.3 1.3c-2.3-2.1-5.2-3.3-8.4-3.3-6.9 0-12.1 5.7-12.1 12.8s5.2 12.7 12.1 12.7c3.1 0 6.1-1.2 8.4-3.3z"
        fill="#b7c0d1"
        fill-rule="nonzero"
      />
      <path
        d="m162.8 12.8h1.9v30.3h-1.9z"
        fill="#b7c0d1"
      />
      <path
        d="m167.9 33.4c0-5.6 4.5-10.1 10.1-10.1s10.1 4.5 10.1 10.1-4.5 10.1-10.1 10.1-10.1-4.5-10.1-10.1m18.3 0c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2 3.7 8.2 8.2 8.2 8.2-3.7 8.2-8.2z"
        fill="#b7c0d1"
        fill-rule="nonzero"
      />
      <path
        d="m206.7 43.1h-1.9v-3.8c-1.1 3-4.2 4.2-6.8 4.2-4.6 0-7.7-3.2-7.7-8.4v-11.3h1.9v11.3c0 4.1 2.4 6.6 5.8 6.6s6.7-1.9 6.8-7.1v-10.8h1.9z"
        fill="#b7c0d1"
        fill-rule="nonzero"
      />
      <path
        d="m227.6 38.9c-1.7 2.9-4.8 4.6-8.2 4.6-5.5.1-10-4.3-10-9.8v-.3c-.1-5.4 4.2-9.9 9.7-10h.3c3.4-.1 6.5 1.7 8.2 4.5v-15.1h1.9v30.3h-1.9zm-8.2 2.7c4.4.1 8.1-3.4 8.2-7.8v-.2c.1-4.5-3.4-8.2-7.9-8.4h-.3c-4.5.2-8 3.9-7.9 8.4.2 4.4 3.7 7.8 7.9 8z"
        fill="#b7c0d1"
        fill-rule="nonzero"
      />
      <g fill="#1c305d">
        <path
          d="m55.6 43.1v-28.5h11.1c8.1 0 12.8 6.2 12.8 14.3s-4.7 14.1-12.8 14.1h-11.1m4.3-3.9h6.7c5.6 0 8.4-4.5 8.4-10.1s-2.8-10.2-8.4-10.2h-6.7z"
          fill-rule="nonzero"
        />
        <path
          d="m101.1 35h-15.3c.4 2.9 3 5 5.9 4.8 2.1.1 4.1-1 5.2-2.8 1.1.5 2.3 1 3.5 1.5-1.7 3.4-5.3 5-8.9 5-5.3.1-9.8-4.1-9.9-9.4v-.7c-.2-5.3 3.9-9.8 9.1-10h.8c5.5 0 9.7 3.9 9.7 10 0 .4 0 1.1-.1 1.6m-4.1-3.1c-.2-2.8-2.7-4.9-5.5-4.7-2.9-.2-5.3 1.9-5.7 4.7z"
          fill-rule="nonzero"
        />
        <path
          d="m119.2 40.3c-1.3 2.1-4.1 3.2-6.5 3.2-5.4 0-9.7-4.3-9.7-9.6v-.4c-.2-5.3 4-9.8 9.3-10h.4c2.3 0 5.2.9 6.5 3.2v-2.8h4.2v19.3h-4.2zm-6-1c3.3 0 5.9-2.6 5.9-5.9s-2.6-5.9-5.9-5.9c-3.1-.1-5.8 2.4-5.9 5.5v.4c-.1 3.2 2.4 5.9 5.6 6 .1 0 .2 0 .3-.1z"
          fill-rule="nonzero"
        />
        <path d="m127.9 13.3h4.2v29.7h-4.2z" />
        <path
          d="m192.2 54.8c0 .6 0 1.1-.2 1.5-.3.9-1 1.5-2.1 1.5-.6 0-1.1-.3-1.5-.7h-.1v.4c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-7.8c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v2.7s0 .1.1 0c.3-.4.9-.7 1.5-.7 1.1 0 1.9.6 2.1 1.6.1.4.2.9.2 1.5zm-.9 0c0-.8-.1-1.1-.3-1.4-.2-.5-.7-.8-1.3-.8s-1 .4-1.2.9c-.1.3-.2.7-.2 1.4 0 .8.1 1.1.2 1.4.2.5.6.9 1.2.9s1.1-.3 1.3-.9c.3-.5.3-.8.3-1.5z"
          fill-rule="nonzero"
        />
        <path
          d="m193.1 59.8v-.4c0-.1 0-.1.1-.1h.1c.9 0 1.1-.3 1.5-1.6v-.1l-1.9-5.6c0-.1 0-.2.1-.2h.5c.1 0 .2 0 .2.1l1.5 4.5c0 .1.1.1.1 0l1.4-4.5c0-.1.1-.1.2-.1h.6c.1 0 .2.1.1.2l-2.1 6.2c-.5 1.5-.9 1.8-2.1 1.8h-.1c-.2 0-.2-.1-.2-.2z"
          fill-rule="nonzero"
        />
        <path
          d="m200.7 57.5v-7.8c0-.1.1-.1.2-.1h.5c.1 0 .1.1.1.1v7.8c0 .1-.1.1-.1.1h-.5c-.1.1-.2 0-.2-.1z"
          fill-rule="nonzero"
        />
        <path
          d="m207.7 53.8v3.8c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-3.6c0-.9-.6-1.4-1.4-1.4s-1.3.5-1.4 1.2v3.8c0 .1-.1.1-.1.1h-.5c-.1 0-.2-.1-.2-.1v-5.6c0-.1.1-.1.2-.1h.5c.1 0 .1.1.1.1v.4s0 .1.1 0c.3-.5.9-.7 1.5-.7 1.2.1 1.9.8 1.9 2.1z"
          fill-rule="nonzero"
        />
        <path
          d="m211.8 52.5h-1.3s-.1 0-.1.1v3.4c0 .7.3 1 1 1h.3c.1 0 .1.1.1.1v.4c0 .1 0 .1-.1.2h-.4c-1 0-1.7-.3-1.7-1.5v-3.6s0-.1-.1-.1h-.7c-.1 0-.1-.1-.1-.1v-.4c0-.1.1-.1.1-.1h.7s.1 0 .1-.1v-1.3c0-.1.1-.1.1-.1h.5c.1 0 .2.1.2.1v1.3s0 .1.1.1h1.3c.1 0 .1.1.1.1v.4c0 .1-.1.1-.1.1z"
          fill-rule="nonzero"
        />
        <path
          d="m217.4 53.7v3.8c0 .1-.1.1-.1.1h-.5c-.1 0-.2-.1-.2-.1v-.4s0-.1-.1 0c-.4.4-1.1.7-1.8.7-1 0-1.9-.5-1.9-1.7s.9-1.9 2.4-1.9h1.3s.1 0 .1-.1v-.4c0-.7-.4-1.3-1.3-1.3-.7 0-1.2.3-1.3.8 0 .1-.1.1-.2.1l-.6-.1c-.1 0-.1 0-.1-.1.1-.8 1-1.4 2.2-1.4 1.4 0 2.1.8 2.1 2zm-.8 2.1v-.9s0-.1-.1-.1h-1.2c-1 0-1.7.4-1.7 1.2 0 .7.6 1 1.3 1 .9.1 1.7-.4 1.7-1.2z"
          fill-rule="nonzero"
        />
        <path
          d="m223.6 54.8c0 .6 0 1-.1 1.4-.3 1-1 1.6-2.1 1.6-.6 0-1.1-.3-1.5-.7h-.1v2.7c0 .1-.1.2-.1.2h-.5c-.1 0-.1-.1-.1-.2v-7.8c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v.4s0 .1.1 0c.3-.4.9-.7 1.5-.7 1.1 0 1.8.6 2.1 1.5 0 .5.1 1 .1 1.6zm-.8 0c0-.7-.1-1.1-.2-1.4-.2-.6-.7-.9-1.3-.9s-1 .4-1.2.9c-.1.3-.2.6-.2 1.4s.1 1.1.2 1.4c.2.5.6.9 1.2.9s1.1-.3 1.3-.8c.1-.4.2-.8.2-1.5z"
          fill-rule="nonzero"
        />
        <path
          d="m229.7 54.8c0 .6 0 1-.1 1.4-.3 1-1 1.6-2.1 1.6-.6 0-1.1-.3-1.5-.7h-.1v2.7c0 .1-.1.2-.1.2h-.5c-.1 0-.1-.1-.1-.2v-7.8c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v.4s0 .1.1 0c.3-.4.9-.7 1.5-.7 1.1 0 1.8.6 2.1 1.5 0 .5.1 1 .1 1.6zm-.9 0c0-.7-.1-1.1-.2-1.4-.2-.6-.7-.9-1.3-.9s-1 .4-1.2.9c-.1.3-.2.6-.2 1.4s.1 1.1.2 1.4c.2.5.6.9 1.2.9s1.1-.3 1.3-.8c.1-.4.2-.8.2-1.5z"
          fill-rule="nonzero"
        />
      </g>
    </g>
  </svg>
</template>
